export const CSS_EDITING_SCOPE_CLASS = 'css-editing-scope';
export const CSS_EDITING_SCOPE_CONTAINER_ID = 'main_MF';
//# sourceMappingURL=constants.js.map